<!-- <button mat-menu-item (click)="openShareDialog()" *ngIf="!isViewCmaPage"> -->
<button mat-menu-item (click)="openShareDialog()" *ngIf="!isViewCmaPage">
  <mat-icon class="mr-1">share</mat-icon> share
</button>

<button
  mat-stroked-button
  class="mr-2 share-icon"
  matTooltip="Share results with your Client"
  matTooltipPosition="below"
  color="primary"
  (click)="openShareDialog()"
  *ngIf="isViewCmaPage"
>
  <mat-icon>share</mat-icon>
</button>

<ng-template #shareReportDialog>
  <form [formGroup]="shareReportForm" (ngSubmit)="shareCmaReport()">
    <div class="addGroupWrap share-report">
      <h2 matDialogTitle>Share Report</h2>
      <button class="close m-3" mat-button mat-dialog-close type="button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>

      <div mat-dialog-content class="pt-2">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-12">
            <!-- Client Name Field -->
            <mat-form-field class="small-form-field w-100 mb-1">
              <mat-label>Client First Name</mat-label>
              <input matInput type="text" formControlName="firstName" />
              <mat-error *ngIf="shareReportForm.get('firstName')?.invalid && shareReportForm.get('firstName')?.touched">
                Client Name is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-6 col-12">
            <mat-form-field class="small-form-field w-100 mb-1">
              <mat-label>Client Last Name</mat-label>
              <input matInput type="text" formControlName="lastName" />
              <mat-error *ngIf="shareReportForm.get('lastName')?.invalid && shareReportForm.get('lastName')?.touched">
                Client Name is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12 col-sm-12 col-12">
            <!-- Client Email Field -->
            <mat-form-field class="small-form-field w-100">
              <mat-label>Client Email</mat-label>
              <input matInput type="email" formControlName="clientEmail" />
              <mat-error
                *ngIf="shareReportForm.get('clientEmail')?.invalid && shareReportForm.get('clientEmail')?.touched"
              >
                Enter a valid email.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div mat-dialog-actions class="share-button">
        <button mat-flat-button color="primary" type="submit" [disabled]="shareReportForm.invalid">Share</button>
      </div>
    </div>
  </form>
</ng-template>
